const o = "style-module__fileChip___yexu1", e = "style-module__uploaded___0K620", l = "style-module__fileName___GMZps", _ = "style-module__crossCircleIcon___8hl8n", n = "style-module__folderIconContainer___5iDP8", c = "style-module__folderIcon___-HLcF", d = "style-module__loading___E3TVK", s = "style-module__loadingIcon___S51cM", t = {
  fileChip: o,
  uploaded: e,
  fileName: l,
  crossCircleIcon: _,
  folderIconContainer: n,
  folderIcon: c,
  loading: d,
  loadingIcon: s
};
export {
  _ as crossCircleIcon,
  t as default,
  o as fileChip,
  l as fileName,
  c as folderIcon,
  n as folderIconContainer,
  d as loading,
  s as loadingIcon,
  e as uploaded
};
